export const FETCH_COUNTY_DETAILS = 'FETCH_COUNTY_DETAILS'